import React from "react";

const CommentFill = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M18 2C9.16 2 2 9.16 2 18c0 2.1.41 4.18 1.21 6.12.81 1.95 1.99 3.71 3.48 5.19L2 34h16c8.84 0 16-7.16 16-16S26.84 2 18 2Zm-7.11 17.78c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78 1.78.8 1.78 1.78-.8 1.78-1.78 1.78Zm7.11 0c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78 1.78.8 1.78 1.78-.8 1.78-1.78 1.78Zm7.11 0c-.98 0-1.78-.8-1.78-1.78s.8-1.78 1.78-1.78 1.78.8 1.78 1.78-.8 1.78-1.78 1.78Z"
            fill={fill}
        />
    </svg>
);

export default CommentFill;